import React from 'react';

// eslint-disable-next-line react/display-name
export const Container = React.forwardRef(({ className = 'container', children, ...props }, ref) => (
  <div ref={ref} className={className} {...props}>
    {children}
  </div>
));
